import * as R from 'ramda';

import { getPluginConfigurationAtLevel } from 'reducers/Plugins';
import { RootState } from 'reducers';

import { ActionType, Configuration } from './types';
import { pluginID } from './constants';

export const defaultActionsConfig: Configuration['optionalActions'] = {
  accountSalesCreditLimit: false,
  reducedAmount: true,
  rowRemoval: true,
  startNewSale: true,
};

export function getConfig(state: RootState): Configuration {
  const existingConfig =
    getPluginConfigurationAtLevel<Configuration>(
      pluginID,
      'Company',
      '',
    )(state) ?? {};
  return R.mergeDeepLeft(existingConfig)({
    optionalActions: defaultActionsConfig,
    managerGroups: {},
  });
}

export const getIsOverrideActionEnabled = (action: ActionType) => (
  state: RootState,
): boolean => {
  const config = getConfig(state);
  const { optionalActions } = config;
  if (!optionalActions) return false;
  return optionalActions[action] === true;
};
